var angular = require('angular');
var _module = require('./index');

_module.directive('aboutListreports', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/about-listreports.tmpl.html',
        scope: {
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;
            }
        ]
    };
}]);
